<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage Home Page</h1>
        </div>
        <div v-if="!showSelectMedia" class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <div class="control">
                      <p class="is-size-2">Top Slider Titles</p>
                      <div class="columns is-multiline">
                        <div
                          v-for="item in featuredSliders"
                          :key="item.id"
                          class="column is-3"
                        >
                          <figure class="image">
                            <img
                              v-if="item.mediadata && item.mediadata.titleImage"
                              :src="item.mediadata.titleImage"
                            />
                          </figure>
                          {{ item.value }}
                        </div>
                      </div>
                      <b-button
                        type="is-primary"
                        @click="showSelectMediaTable('featured-sliders')"
                        >Add Titles</b-button
                      >
                    </div>
                  </div>
                  <div
                    class="is-divider"
                    style="border-top: 1px solid #eee;width: 100%;"
                  ></div>
                  <div class="column is-12">
                    <div class="control">
                      <p class="is-size-2">Featured Shelves</p>
                      <div
                        v-for="shelf in featuredShelves"
                        :key="shelf.name"
                        class="has-margin-top-15"
                      >
                        <strong class="is-size-4">{{ shelf.name }}</strong>
                        <a
                          class="has-margin-left-15"
                          href=""
                          @click.prevent="
                            showSelectMediaTable('featured-shelves', shelf.name)
                          "
                          >Edit</a
                        >
                        <div class="columns is-multiline">
                          <div
                            v-for="item in shelf.titles"
                            :key="item.id"
                            class="column is-3"
                          >
                            <figure class="image">
                              <img
                                v-if="
                                  item.mediadata && item.mediadata.titleImage
                                "
                                :src="item.mediadata.titleImage"
                              />
                            </figure>
                            {{ item.value }}
                          </div>
                        </div>
                      </div>
                      <b-button
                        type="is-primary"
                        class="has-margin-top-15"
                        @click="showSelectMediaTable('featured-shelves')"
                        >Add Shelf</b-button
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="is-divider"
                  style="border-top: 1px solid #eee;width: 100%;margin-bottom: 30px;"
                ></div>
                <div class="has-text-centered">
                  <div class="is-block has-margin-bottom-15">
                    <button
                      class="button is-primary is-medium btn-align no-lh raised primary-btn"
                      :disabled="loading"
                      :class="{ 'is-loading': loading }"
                      @click="submit"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showSelectMedia" style="width: 100%; display: block;">
          <ValidationObserver ref="observer" v-slot="{ passes }">
            <ValidationProvider
              v-if="selected === 'featured-shelves'"
              v-slot="{ errors }"
              name="Shelf Name"
              rules="required"
            >
              <b-field
                label="Shelf Name"
                :type="{ 'is-danger': errors.length > 0 }"
                :message="errors[0]"
              >
                <b-input v-model="shelf" />
              </b-field>
            </ValidationProvider>
            <b-table
              :data="featuredTitles"
              :checked-rows.sync="checkedRows"
              checkable
            >
              <template slot-scope="props">
                <b-table-column field="" label="" width="40" numeric>
                  <img
                    v-if="props.row.mediadata && props.row.mediadata.titleImage"
                    :src="props.row.mediadata.titleImage"
                  />
                </b-table-column>

                <b-table-column field="title" label="Title">
                  <router-link
                    :to="{ name: 'MediaDetail', params: { id: props.row.id } }"
                    >{{ props.row.value }}</router-link
                  >
                </b-table-column>

                <b-table-column field="media_type" label="Type">
                  {{ props.row.media_type | capitalize }}
                </b-table-column>
              </template>
            </b-table>
            <div class="has-text-centered">
              <div class="is-block has-margin-bottom-15">
                <button
                  class="button is-medium has-margin-right-5"
                  :disabled="loading"
                  :class="{ 'is-loading': loading }"
                  @click="showSelectMedia = false"
                >
                  Cancel
                </button>
                <button
                  class="button is-primary is-medium btn-align no-lh raised primary-btn"
                  :disabled="loading"
                  :class="{ 'is-loading': loading }"
                  @click="passes(updateSelected)"
                >
                  Update
                </button>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Filters from '@/mixins/filters'
import CardComponent from '@/components/CardComponent'
import MediaApi from '@/api/media'
import HomeSettingsApi from '@/api/homeSettings'
export default {
  name: 'ManageHomePage',
  components: {
    CardComponent
  },
  mixins: [Filters],
  metaInfo: {
    title: 'Manage Home Page'
  },
  computed: {
    ...mapGetters(['user'])
  },
  async created() {
    let response = await MediaApi.featured()
    if (response && response.length > 0) {
      response.forEach(item => {
        item.mediadata = JSON.parse(item.mediadata)
      })
      this.featuredTitles = response
    }
    let result = await HomeSettingsApi.get()
    if (result && result.length > 0) {
      let settings = JSON.parse(result[0].settings)
      settings.featuredSliders.forEach(id => {
        const found = this.featuredTitles.find(title => title.id === id)
        if (found) {
          this.featuredSliders.push(found)
        }
      })
      settings.featuredShelves.forEach(shelf => {
        let titles = []
        shelf.titles.forEach(id => {
          let found = this.featuredTitles.find(title => title.id === id)
          if (found) {
            titles.push(found)
          }
        })
        this.featuredShelves.push({ name: shelf.name, titles: titles })
      })
    }
    this.initialized = true
  },
  data() {
    return {
      loading: false,
      initialized: false,
      featuredSliders: [],
      featuredShelves: [],
      featuredTitles: [],
      showSelectMedia: false,
      checkedRows: [],
      selected: '',
      shelf: ''
    }
  },
  methods: {
    ...mapActions(['getUser']),
    showSelectMediaTable(type, shelf) {
      this.checkedRows = []

      this.showSelectMedia = true
      this.selected = type
      this.shelf = ''
      if (shelf) {
        this.shelf = shelf
        let found = this.featuredShelves.find(item => item.name === this.shelf)
        if (found) {
          this.checkedRows = found.titles
        }
      }
      if (this.selected === 'featured-sliders') {
        this.checkedRows = this.featuredSliders
      }
    },
    submit() {
      this.loading = true
      HomeSettingsApi.save({
        settings: JSON.stringify({
          featuredSliders: this.featuredSliders.map(item => item.id),
          featuredShelves: this.featuredShelves.map(item => {
            return {
              name: item.name,
              titles: item.titles.map(title => title.id)
            }
          })
        })
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Home Page Settings updated successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error saving Home Page Settings',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    updateSelected() {
      this.showSelectMedia = false
      switch (this.selected) {
        case 'featured-sliders':
          this.featuredSliders = this.checkedRows
          break
        case 'featured-shelves': {
          let found = this.featuredShelves.find(
            item => item.name === this.shelf
          )
          if (found) {
            found.titles = this.checkedRows
          } else {
            this.featuredShelves.push({
              name: this.shelf,
              titles: this.checkedRows
            })
          }
        }
      }
    }
  }
}
</script>
